import { KeySections, KeySubjects } from 'civil-status/constants/keys-subjects-section';

export const keyChangeActFromSubject = (keySubjectCurrent?: string): string => {
  if (!keySubjectCurrent) {
    return '';
  }

  switch (keySubjectCurrent) {
    case KeySubjects.keySposo:
      return KeySections.keyMatrimonioAttoNascitaSposo;
    case KeySubjects.keySposa:
      return KeySections.keyMatrimonioAttoNascitaSposa;
    case KeySubjects.keyFiglio:
      return KeySections.keyMatrimonioAttoNascitaFiglio;
    case KeySubjects.keyDeceduto:
      return KeySections.keyMorteAttoNascitaDeceduto;
    case KeySubjects.keyUniciv1:
      return KeySections.keyUnioneCivileAttoNascitaConiuge1;
    case KeySubjects.keyUniciv2:
      return KeySections.keyUnioneCivileAttoNascitaConiuge2;
    case KeySubjects.keyIntNas2C1:
    case KeySubjects.keyIntNas2:
      return KeySections.keyAttoNascitaFiglio;
    case KeySubjects.keyConiuge:
      return KeySections.keyAttoNascitaConiuge;
    case KeySubjects.keyUnitoCivilmente:
      return KeySections.keyAttoNascitaUnito;
    case KeySubjects.keyIntest:
    case KeySubjects.keyIntest1:
      return KeySections.keyCittadinanzaAttoNascita;
    default:
      return '';
  }
};
